import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import './InitialsIcon.scss';

const useStyles = makeStyles(theme => ({
  initialIcon: {
    backgroundColor: theme.palette.primary.main
  }
}));

export default function IntitialsIcon(props) {

  const { name,id } = props;

  if (!name) {
    return null;
  }

  let initials = name.split(" ").map((n) => n[0]).join("");

  let classes = useStyles();

  return (
    <React.Fragment>
      <div className={`intials-icon ${classes.initialIcon}`} id={id} name='initials-icon'>
        {initials}
      </div>
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/components/Common/InitialsIcon.js